/* eslint-disable */
import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import tecnicosReducer from 'redux/app/tecnicosReducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  app:tecnicosReducer
});

export default reducers;
